import React from 'react'
import ReactDOM from 'react-dom'
import { ThemeProvider, CssBaseline } from '@material-ui/core'
import reportWebVitals from './reportWebVitals'

import 'index.scss'
import AppRoutes from 'routes/App.routes'
import theme from 'materialUiTheme'
import AuthProvider from 'authentication/AuthProvider'
import FirebaseProvider from 'authentication/FirebaseProvider'
import ApiProvider from 'api/ApiProvider'

ReactDOM.render(
    <React.StrictMode>
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <FirebaseProvider>
                <AuthProvider>
                    <ApiProvider>
                        <AppRoutes />
                    </ApiProvider>
                </AuthProvider>
            </FirebaseProvider>
        </ThemeProvider>
    </React.StrictMode>,
    document.getElementById('root')
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
